import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import logo from '../../../assets/img/logo.jpg'
import './Header.sass'

import Navigation from '../Navigation'

const Header = ({ logo }) => (
  <header className="Header" role="header">
    <Link to="/">
      <Img
        className="Header-logo"
        fadeIn={true}
        resolutions={logo.resolutions}
        alt="Muvko - logo"
      />
    </Link>
    <Navigation />
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js